module.exports = __webpack_public_path__ + "img/weihuo.b82dc866.png";